import THEME from 'pobble-components/dist/theme'

const { COLORS, FONT_SIZES } = THEME

export default {
  category: {
    position: 'relative',
    cursor: 'pointer',
    textTransform: 'capitalize',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL,
    ...FONT_SIZES.HEADING_DEFAULT.STYLE,
    padding: '20px',
    borderBottom: '1px solid #ececec',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '4px',
      right: '0',
      top: '0',
      height: '100%',
      background: 'transparent'
    },
    '&:hover': {
      '&:after': {
        backgroundColor: '#ececec'
      }
    }
  },
  active: {
    color: COLORS.BLUE.NORMAL,
    '&:after': {
      backgroundColor: `${COLORS.BLUE.NORMAL} !important`
    }
  }
}
